import React from 'react';
import { AIChatPanel } from './AIChatPanel';

interface ChatPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

const ChatPanel: React.FC<ChatPanelProps> = ({ isOpen, onClose }) => {
  return (
    <aside
      className={`${
        isOpen ? 'w-80' : 'w-0'
      } transition-all duration-300 border-l border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-800 overflow-hidden flex-shrink-0 flex flex-col`}
    >
      <AIChatPanel isOpen={isOpen} onClose={onClose} />
    </aside>
  );
};

export default ChatPanel;
